import { getCookie } from '@shopee/cookie';

export function getSpcClientIdCookie(): string | undefined {
  return getCookie('SPC_CLIENTID') || undefined;
}
